var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptywallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.54 14.05C18.12 14.46 17.88 15.05 17.94 15.68C18.03 16.76 19.02 17.55 20.1 17.55H22V18.74C22 20.81 20.31 22.5 18.24 22.5H8.14C8.97 21.77 9.5 20.7 9.5 19.5C9.5 17.29 7.71 15.5 5.5 15.5C4.56 15.5 3.69 15.83 3 16.38V12.01C3 9.94001 4.68999 8.25 6.75999 8.25H18.24C20.31 8.25 22 9.94001 22 12.01V13.45H19.98C19.42 13.45 18.91 13.67 18.54 14.05Z",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.0101V8.34014C3 7.15014 3.73 6.09009 4.84 5.67009L12.78 2.67009C14.02 2.21009 15.35 3.12012 15.35 4.45012V8.25011",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0588 14.4702V16.5302C23.0588 17.0802 22.6188 17.5302 22.0588 17.5502H20.0988C19.0188 17.5502 18.0288 16.7602 17.9388 15.6802C17.8788 15.0502 18.1188 14.4602 18.5388 14.0502C18.9088 13.6702 19.4188 13.4502 19.9788 13.4502H22.0588C22.6188 13.4702 23.0588 13.9202 23.0588 14.4702Z",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H14.5",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C9.5 20.7 8.97 21.77 8.14 22.5C7.43 23.12 6.51 23.5 5.5 23.5C3.29 23.5 1.5 21.71 1.5 19.5C1.5 18.24 2.08 17.11 3 16.38C3.69 15.83 4.56 15.5 5.5 15.5C7.71 15.5 9.5 17.29 9.5 19.5Z",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.25V19.75L4.5 20.5",
    stroke: "#6A6B6F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptywallet);
export default __webpack_public_path__ + "static/media/emptywallet.985b9d92287bc6b3876e573d8f180578.svg";
export { ForwardRef as ReactComponent };